// material-ui
import { Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="subtitle2" component={Link} href="https://web.dev-codes.io" target="_blank" underline="hover">
      &copy; Dev Codes SAS
    </Typography>
  </Stack>
);

export default AuthFooter;
